import type { Builder, PaginatedResponse } from "../../types.ts";
import type { CustomerInvoice } from "./types.ts";

export const buildCustomerInvoiceEndpoints = (builder: Builder) => ({
	getCustomerInvoiceById: builder.query<
		CustomerInvoice,
		{
			companyDomainId: string;
			legalEntityId: string;
			invoiceId: string;
		}
	>({
		query: ({ companyDomainId, legalEntityId, invoiceId }) => {
			return {
				url: `/v1/company-domain/${companyDomainId}/legal-entity/${legalEntityId}/customer-invoice/${invoiceId}`,
			};
		},
		providesTags: (_result, error, arg) => {
			if (error) {
				return ["CustomerInvoice"];
			}
			return [
				"CustomerInvoice",
				{
					type: "CustomerInvoice",
					id: arg.invoiceId,
				},
			];
		},
	}),
	getCustomerInvoices: builder.query<
		PaginatedResponse<CustomerInvoice>,
		{ companyDomainId: string; legalEntityId: string; take: number }
	>({
		query: ({ companyDomainId, legalEntityId, take }) => {
			return {
				url: `/v1/company-domain/${companyDomainId}/legal-entity/${legalEntityId}/customer-invoice`,
				params: {
					take,
				},
			};
		},
		providesTags: (result) => {
			if (!result) {
				return ["CustomerInvoice"];
			}
			return [
				"CustomerInvoice",
				...result.items.map((invoice) => {
					return {
						type: "CustomerInvoice" as const,
						id: invoice.id,
					};
				}),
			];
		},
	}),
	getCustomerInvoiceFile: builder.query<
		Blob,
		{
			companyDomainId: string;
			legalEntityId: string;
			invoiceId: string;
			fileId: string;
		}
	>({
		query({ companyDomainId, fileId, invoiceId, legalEntityId }) {
			return {
				url: `/v1/company-domain/${companyDomainId}/legal-entity/${legalEntityId}/customer-invoice/${invoiceId}/files/${fileId}`,
				responseHandler: (response) => response.blob(),
			};
		},
	}),
});
